import $ from "jquery";
import { Howl } from "howler";
import logger from "./logger";

const preloadSounds = [
  ["tap_start", "public/sounds/tap_start.mp3"],
  ["quiz_correct", "public/sounds/quiz_correct.mp3"],
  ["quiz_wrong", "public/sounds/quiz_wrong.mp3"],
  ["result_low", "public/sounds/result_low.mp3"],
  ["result_mid", "public/sounds/result_mid.mp3"],
  ["result_high", "public/sounds/result_high.mp3"],
];

class SoundController {
  constructor() {
    this.soundInstances = {};
  }

  load() {
    return new Promise((resolve, reject) => {
      const requests = preloadSounds.map((arr) => {
        const key = arr[0];
        const url = arr[1];
        return this._preloadEach(key, url);
      });
      $.when(...requests)
        .then((...results) => {
          logger.info("[SoundController] all sound loaded", results);
          resolve(results);
        })
        .fail((...results) => {
          reject(results);
        });
    });
  }

  _preloadEach(key, url) {
    const dfd = $.Deferred();
    this.soundInstances[key] = new Howl({
      src: url,
    });
    this.soundInstances[key].once("load", () => {
      logger.info("[SoundController] sound loaded > %s", key);
      dfd.resolve(key);
    });
    this.soundInstances[key].once("loaderror", () => {
      logger.info("[SoundController] sound loaderror > %s", key);
      dfd.reject(key);
    });
    return dfd.promise();
  }

  playSound(key) {
    const sound = this.soundInstances[key];
    if (!sound) return;
    sound.play();
  }

  get isLoaded() {
    return preloadSounds.every(([key]) => {
      return this.soundInstances[key] != null;
    });
  }
}

export default new SoundController();
